@import 'theme/theme';

.view {
    display: flex;
    color: @darkGrayColor;
    align-items: center;
    gap: 0.5em;

    &.showMargin {
        margin: @margin;
    }
}

.centerHorizontal {
    justify-content: center;
}

.centerVertical {
    align-items: center;
    height: 100%;
}

.showMargin {
    .spinner {
        margin: @smallMargin;
    }
}
